import {useContext} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {HalfwayContext} from "../../context/HalfwayContext";
import {HalfwayContextType} from "../../types/HalfwayContextType";

export const Success = () => {

    const { courseId: contextCourseId } = useContext(HalfwayContext) as HalfwayContextType;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const courseId = searchParams.get('courseId') || contextCourseId;
    const orderId = searchParams.get('orderId');

    return (
        <div className='flex flex-col bg-slate-50 p-6 min-h-screen'>
            <div className='flex items-center justify-center flex-1'>
                <div className='flex flex-col bg-white w-full max-w-md items-center rounded-2xl p-8 shadow-card animate-scale-in'>

                    {/* Animated Checkmark */}
                    <div className='check-circle mb-6'>
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="36" cy="36" r="34" stroke="#16a34a" strokeWidth="3" fill="#dcfce7"/>
                            <path className="check-mark"
                                  d="M22 36L32 46L50 26"
                                  stroke="#16a34a" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"
                                  fill="none"/>
                        </svg>
                    </div>

                    <h1 className='text-2xl font-bold text-slate-900 mb-2'>Order Placed!</h1>

                    <p className='text-slate-500 text-center text-sm leading-relaxed max-w-xs'>
                        Payment can be made at the Halfway House. Your order will be ready when you arrive.
                    </p>

                    {courseId && orderId && (
                        <Link
                            to={`/orders/${encodeURIComponent(courseId)}/${encodeURIComponent(orderId)}`}
                            className='mt-6 w-full rounded-xl border border-maroon px-4 py-3 text-center font-semibold text-maroon hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'>
                            View receipt
                        </Link>
                    )}

                    {/* Back to Menu */}
                    {courseId && (
                        <button
                            type='button'
                            onClick={() => navigate(`/${courseId}`)}
                            className='mt-6 w-full'>
                            <div className='button'>
                                <span>Place Another Order</span>
                            </div>
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}
